const Install = () => {
  return (
    <section className="flex flex-col justify-center items-center mt-2 mb-10 sm:mb-10">
      <p className="text-xl sm:text-2xl font-semibold mb-6 sm:mb-8 font-prata">
        Download Our App
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
        <a
          href="https://play.google.com/store/apps/details?id=com.rizzsoftware.ceviliyar&hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assests/playStore.png"
            alt="play store"
            className="h-[40px] sm:h-[50px] w-[130px] sm:w-[160px]"
          />
        </a>
        <a
          href="https://apps.apple.com/in/app/ceviliyar/id6739484725"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assests/appStore.png"
            alt="app store"
            className="h-[40px] sm:h-[50px] w-[130px] sm:w-[160px]"
          />
        </a>
      </div>
    </section>
  );
};
export default Install;
